// extracted by mini-css-extract-plugin
export default {"form-items":"forgotPasswordForm_form-items__5SSzY","form-input-block":"forgotPasswordForm_form-input-block__SsJxF"};